import './Style.scss';

const Style = ({ children }) => {
    return children;
};

export default Style;
